// const attachmenturl = "https://apilinsoatours.odisoft.in";
const attachmenturl = "https://api.linsoatours.com";
export default attachmenturl;
